module.exports = require('./dist').default
